<div class="wrapper">
  <table class="w-100 product-table">
    <thead>
      <tr>
        <th>{{ 'Product' | translate }}</th>
        <th>
          <span class="d-none d-sm-block">{{ 'Quantity' | translate }}</span>
          <span class="d-sm-none">{{ 'Qty' | translate }}</span>
        </th>
        <th>{{ 'Cost' | translate }}</th>
        <th>{{ 'Total' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of dataProvider">
        <tr>
          <td>
            <div class="d-flex gap-4">
              <div class="cart-list-img">
                <img *ngIf="row.imageUrl" [src]="row.imageUrl" />
              </div>
              <div class="d-none d-xxl-flex flex-column justify-content-between gap-2">
                <div class="text-decoration-none">
                  <div class="title bold-text">{{ removeCurrencyAndPriceFromName(row.name) }}</div>
                </div>
                <p class="text-16 description">
                  {{ row.shortDescription }}
                </p>
                <div>
                  <button
                    *ngIf="editable"
                    class="btn btn-link remove bold-text text-16"
                    type="button"
                    (click)="itemRemove.emit(row.productId)"
                  >
                    {{ 'Remove' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="d-flex quantity">
              <button (click)="decrementQuantity(row)">
                <fa-icon [icon]="['far', 'minus']"></fa-icon>
              </button>
              <div class="d-flex justify-content-center align-items-center">{{ row.quantity }}</div>
              <button (click)="incrementQuantity(row)">
                <fa-icon [icon]="['far', 'plus']"></fa-icon>
              </button>
            </div>
          </td>
          <td>
            <div class="text-16">{{ row.points | number }} {{ 'points' | translate }}</div>
          </td>
          <td>
            <div class="text-16 bold-text">{{ row.points * row.quantity | number }} {{ 'points' | translate }}</div>
          </td>
        </tr>

        <tr class="mobile-row">
          <td colspan="4">
            <div class="d-flex flex-column justify-content-between gap-2 mobile-wrapper">
              <div class="text-decoration-none">
                <div class="title bold-text">{{ removeCurrencyAndPriceFromName(row.name) }}</div>
              </div>
              <p class="text-16 description">
                {{ row.shortDescription }}
              </p>
              <div>
                <button
                  *ngIf="editable"
                  class="btn btn-link remove bold-text text-16"
                  type="button"
                  (click)="itemRemove.emit(row.productId)"
                >
                  {{ 'Remove' | translate }}
                </button>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
